import {customPageActionTypes} from '../actions/custom-page';

const customPageReducer = (state = {}, action) => {
  switch (action.type) {
    case customPageActionTypes.CUSTOM_PAGE:
      return action.payload;

    default:
      return state;
  }
};

export default customPageReducer;
